/* eslint-disable functional/no-let, functional/no-loop-statement */
/* eslint-disable functional/no-expression-statement, functional/no-class */
/* eslint-disable functional/no-this-expression */
import httpStatus, {
  ACCEPTED,
  BAD_GATEWAY,
  BAD_REQUEST,
  CONFLICT,
  CONTINUE,
  CREATED,
  EXPECTATION_FAILED,
  FAILED_DEPENDENCY,
  FORBIDDEN,
  GATEWAY_TIMEOUT,
  GONE,
  HTTP_VERSION_NOT_SUPPORTED,
  IM_A_TEAPOT,
  INSUFFICIENT_SPACE_ON_RESOURCE,
  INSUFFICIENT_STORAGE,
  INTERNAL_SERVER_ERROR,
  LENGTH_REQUIRED,
  LOCKED,
  METHOD_FAILURE,
  METHOD_NOT_ALLOWED,
  MOVED_PERMANENTLY,
  MOVED_TEMPORARILY,
  MULTI_STATUS,
  MULTIPLE_CHOICES,
  NETWORK_AUTHENTICATION_REQUIRED,
  NO_CONTENT,
  NON_AUTHORITATIVE_INFORMATION,
  NOT_ACCEPTABLE,
  NOT_FOUND,
  NOT_IMPLEMENTED,
  NOT_MODIFIED,
  OK,
  PARTIAL_CONTENT,
  PAYMENT_REQUIRED,
  PERMANENT_REDIRECT,
  PRECONDITION_FAILED,
  PRECONDITION_REQUIRED,
  PROCESSING,
  PROXY_AUTHENTICATION_REQUIRED,
  REQUEST_HEADER_FIELDS_TOO_LARGE,
  REQUEST_TIMEOUT,
  REQUEST_TOO_LONG,
  REQUEST_URI_TOO_LONG,
  REQUESTED_RANGE_NOT_SATISFIABLE,
  RESET_CONTENT,
  SEE_OTHER,
  SERVICE_UNAVAILABLE,
  SWITCHING_PROTOCOLS,
  TEMPORARY_REDIRECT,
  TOO_MANY_REQUESTS,
  UNAUTHORIZED,
  UNPROCESSABLE_ENTITY,
  UNSUPPORTED_MEDIA_TYPE,
  USE_PROXY,
} from 'http-status-codes';

// eslint-disable-next-line @typescript-eslint/naming-convention
export type STATUS_CODE = typeof ACCEPTED |
typeof BAD_GATEWAY |
typeof BAD_REQUEST |
typeof CONFLICT |
typeof CONTINUE |
typeof CREATED |
typeof EXPECTATION_FAILED |
typeof FAILED_DEPENDENCY |
typeof FORBIDDEN |
typeof GATEWAY_TIMEOUT |
typeof GONE |
typeof HTTP_VERSION_NOT_SUPPORTED |
typeof IM_A_TEAPOT |
typeof INSUFFICIENT_SPACE_ON_RESOURCE |
typeof INSUFFICIENT_STORAGE |
typeof INTERNAL_SERVER_ERROR |
typeof LENGTH_REQUIRED |
typeof LOCKED |
typeof METHOD_FAILURE |
typeof METHOD_NOT_ALLOWED |
typeof MOVED_PERMANENTLY |
typeof MOVED_TEMPORARILY |
typeof MULTI_STATUS |
typeof MULTIPLE_CHOICES |
typeof NETWORK_AUTHENTICATION_REQUIRED |
typeof NO_CONTENT |
typeof NON_AUTHORITATIVE_INFORMATION |
typeof NOT_ACCEPTABLE |
typeof NOT_FOUND |
typeof NOT_IMPLEMENTED |
typeof NOT_MODIFIED |
typeof OK |
typeof PARTIAL_CONTENT |
typeof PAYMENT_REQUIRED |
typeof PERMANENT_REDIRECT |
typeof PRECONDITION_FAILED |
typeof PRECONDITION_REQUIRED |
typeof PROCESSING |
typeof PROXY_AUTHENTICATION_REQUIRED |
typeof REQUEST_HEADER_FIELDS_TOO_LARGE |
typeof REQUEST_TIMEOUT |
typeof REQUEST_TOO_LONG |
typeof REQUEST_URI_TOO_LONG |
typeof REQUESTED_RANGE_NOT_SATISFIABLE |
typeof RESET_CONTENT |
typeof SEE_OTHER |
typeof SERVICE_UNAVAILABLE |
typeof SWITCHING_PROTOCOLS |
typeof TEMPORARY_REDIRECT |
typeof TOO_MANY_REQUESTS |
typeof UNAUTHORIZED |
typeof UNPROCESSABLE_ENTITY |
typeof UNSUPPORTED_MEDIA_TYPE |
typeof USE_PROXY;

export default class HttpError extends Error {
  constructor(
    status: STATUS_CODE = httpStatus.INTERNAL_SERVER_ERROR as STATUS_CODE,
    ...messages: readonly string[]
  ) {
    super(
      `Route rejected with ${httpStatus.getStatusText(status)}`,
    );
    this.status = status;
    this.messages = [httpStatus.getStatusText(status)].concat(messages);
  }

  readonly status: STATUS_CODE;

  readonly messages: readonly string[];
}
